<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Trading Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Trading Number</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Trading Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date" :max="maxTradingDate" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>    

                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                            <b-input-group-prepend><label style="width:160px;">Trading Store/Warehouse</label></b-input-group-prepend>
                                <b-form-select v-model="model.idStore" :plain="true" :options="Warehouse" :state="!$v.model.idStore.$error"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Note/Descript.</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>Note &nbsp;</span></b-input-group-prepend>
                                <b-form-input v-model="model.uraian"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>     
                    <b-input-group >
                        <b-input-group-prepend><label>Trading to(Buyer)</label></b-input-group-prepend>
                        <b-form-radio-group  v-model="model.employee" name="radioIndividu" class="ml-1 mt-1" :state="!$v.model.employee.$error">
                            <b-form-radio :value="1">Employee</b-form-radio>
                            <b-form-radio :value="0">Public</b-form-radio>
                        </b-form-radio-group>
                        <b-form-input v-model="model.pembeli" :state="!$v.model.pembeli.$error"></b-form-input>                                        
                        <b-input-group-append v-if="(model.employee==1)">
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblTradingLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="issuedLines.items"
                    :fields="issuedLines.fields"
                    :current-page="issuedLines.page"
                    :per-page="issuedLines.limit"
                    show-empty
                    >
                    <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                    </template>
                    <template v-slot:cell(itemname)="data">
                        {{data.item.itemname}} <span v-if="(data.item.remark)"> | {{data.item.remark}}</span>
                    </template>
                    <template v-slot:cell(qtyTrading)="data">
                        {{data.item.qtyTrading}} {{data.item.invunitom}}
                    </template>
                    <template v-slot:cell(priceTrading)="data">
                        {{data.item.priceTrading|numFormat}}
                    </template>
                    <template v-slot:cell(valueTrading)="data">
                        {{data.item.valueTrading|numFormat}}
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editTradingLines(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delTradingLines(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                            <b-row  align-h="center">
                                <b-col lg="7" >
                                    <b-input-group>
                                        <b-input-group-prepend><label>Item Inventory</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="issuedLinesObj.iteminfo" @keyup.13.native="lkuItemShow=true" :state="!$v.issuedLinesObj.iteminfo.$error"></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="lkuItemShow=true">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col md="7">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                                                <b-form-input readonly v-model="issuedLinesObj.typeseries" ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="5">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Group</span></b-input-group-prepend>
                                                <b-form-input readonly v-model="issuedLinesObj.itemcategory" ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   
                                    <b-form-row v-show="(issuedLinesObj.qtyUndefined==0)">
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity Available</label></b-input-group-prepend>
                                                <b-form-input v-model="issuedLinesObj.qtyAvail" type="number" readonly></b-form-input>
                                                <b-form-input v-model="issuedLinesObj.invunitom" readonly class="ml-1"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col md="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity Trading</label></b-input-group-prepend>
                                                <b-form-input v-model="issuedLinesObj.qtyTrading" type="number"  :state="!$v.issuedLinesObj.qtyTrading.$error" ></b-form-input>
                                                <b-form-input v-model="issuedLinesObj.invunitom" readonly class="ml-1"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >
                                    <b-input-group v-show="(issuedLinesObj.qtyUndefined==1)">
                                        <b-input-group-prepend><label>Remark/Note</label></b-input-group-prepend>
                                        <b-form-input v-model="issuedLinesObj.remark" :state="!$v.issuedLinesObj.remark.$error"></b-form-input>
                                    </b-input-group>

                                </b-col>
                                <b-col lg="5">
                                            <b-input-group>
                                                <b-input-group-prepend><label >Price Item</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="issuedLinesObj.priceTrading" :precision="2" :disabled="((issuedLinesObj.barangbekas==0) && ((issuedLinesObj.priceTrading || 0)!=0))"></my-number>
                                                <b-form-checkbox id="chkPPN" class="ml-1 mt-2" v-model="issuedLinesObj.kenappn" value=1 unchecked-value=0 @change="calcTaxes()" >PPN(VAT)</b-form-checkbox>
                                            </b-input-group>
                                            <b-input-group>
                                                <b-input-group-prepend><label>Price Discount</label></b-input-group-prepend>
                                                <my-number v-model="issuedLinesObj.priceDiscPc" :precision="2" ></my-number>
                                                <b-input-group-append><span class="ml-1 pt-2 mr-2"><i class="fa fa-percent"></i></span></b-input-group-append>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="issuedLinesObj.priceDisc" :precision="2" style="width:40% !important;"></my-number>
                                            </b-input-group>                                          
                                            <b-input-group>
                                                <b-input-group-prepend><label >Amount Trading</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="issuedLinesObj.valueTrading" :precision="2" disabled :state="!$v.issuedLinesObj.valueTrading.$error"></my-number>
                                            </b-input-group>

                                    <b-row class="justify-content-center mt-1">
                                        <div style="width:400px;">
                                            <b-input-group >
                                                <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                                <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-success mr-1" @click="saveTradingLines()">Update</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                    </b-row>

                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>                        
                </b-table>
                <b-form-row>
                    <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="addTradingLines" >Add Trading item</b-button>                          
                        <div class="ml-2">
                            Showing
                            {{(issuedLines.page - 1) * issuedLines.limit + 1}}
                            to
                            {{issuedLines.page * issuedLines.limit}}
                            <strong>
                            of
                            {{issuedLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="issuedLines.total"
                        :per-page="issuedLines.limit"
                        v-model="issuedLines.page"
                    ></b-pagination>
                    </b-col>
                </b-form-row>
            </b-card>    
            <b-row align-h="between" class="mt-1">
                <b-col lg="8" xl="7">
                    <b-input-group>
                        <b-input-group-prepend><label>Note/Descript.</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian"></b-form-input>
                    </b-input-group>
                    <!-- <b-input-group >
                        <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCashflow('model')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group> -->
                        <b-form-row>
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>No. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.nofaktur" ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col lg="5">
                                <b-input-group >
                                    <b-input-group-prepend><label >Tgl. Faktur Pajak</label></b-input-group-prepend>
                                    <b-form-input v-model="model.tglfaktur" type="date" ></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-form-row>                      
                        <b-row v-if="(model.matauang !== uanguser)">
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label >Exch. Rate <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                </b-input-group-prepend>
                                <my-number  class="form-control text-right" separator="," v-model="model.kursPPN" :state="!$v.model.kursPPN.$error"></my-number>
                            </b-input-group>
                            </b-col>
                            <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: right !important;">Kurs Pajak <strong>{{model.matauang}}</strong></label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="model.kursPPN"  :state="!$v.model.kursPPN.$error"></my-number>
                                </b-input-group>
                            </b-col>
                        </b-row>            
                        <b-row class="justify-content-center mt-5">
                            <div style="width:450px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>

                </b-col>
                <b-col lg="4">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Gross</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlgross" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" :readonly="(model.calcDisc===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlvat" :precision="2" :readonly="(model.calcVAT===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                        </b-input-group>
                    </div>
                </b-col>
            </b-row>


        </b-card>
        <!-- <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Item Inventory" :key="model.idStore" :centered="true">
            <lku-item @click="onSelectLkuItem" :idStore="model.idStore"></lku-item>
        </b-modal>         -->
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Available Inventory" :key="model.idStore" :centered="true">
            <lku-item @click="onSelectLkuItem" :idStore="model.idStore" ></lku-item>
        </b-modal>        
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required, requiredUnless, requiredIf, numeric } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuItem from "../lookup/lkuItemavailable"; 
import lkuCrew from "../lookup/lkuCrewlazzy";
import trading from "../../apis/logistic_trading";
import dimension from "../../apis/dimension";
toastr.init();

export default {   
    components: { myNumber, vDim, lkuItem, lkuCrew},
    mixins: [validationMixin],
    validations: {
            model: {
                idStore: { required },
                tanggal: { required },
                employee: { required },
                pembeli: { required },
                matauang: { required },
                // nofaktur: {required : (function() {
                //     if ((this.model.ttlvat || 0) == 0) {
                //         return true;
                //     } else if ((this.model.nofaktur || '')==''){
                //         return false;
                //     } else return true;
                // })},
                // tglfaktur: {required : (function() {
                //     if ((this.model.ttlvat || 0) == 0) {
                //         return true;
                //     } else if (!(this.model.tglfaktur)){
                //         return false;
                //     } else return true;
                // })},
                ttlamtdue: { required },
                kursPPN: {required : (function() {
                    if ((this.model.ttlvat || 0) == 0) {
                        return true;
                    } else if ((this.model.kursPPN || 0) == 0){
                        return false;
                    } else return true;
                })},
            },
            issuedLinesObj: {
                iteminfo: { required },
                remark: {required : (function() {
                    if ((this.issuedLinesObj.qtyUndefined || 0) == 0) {
                        return true;
                    } else if ((this.issuedLinesObj.remark || '')==''){
                        return false;
                    } else return true;
                })},
                qtyTrading: { required },
                valueTrading: { numeric, required }
            },
    }, 
    data() {
        return {
            saveEnabled:true,
            inputBerlanjut: 1,
            inputLineBerlanjut: 1,
            lkuItemShow:false,
            lkuMrShow:false,
            lkuCrewData,
            lkuCrewShow:false,
            updateDimHdr:false,
            updateDimDtl:true,
            uanguser: this.$store.state.user.matauang,
            model:{idStore:'',sales:0,requestno:'',arrItem:[], employee:1, pembeli:'', matauang:this.$store.state.user.matauang, calcVAT:1, calcDisc:1 },
            issuedLines: {
                items: [],
                selected:{},
                fields: [
                    {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                    {
                        key: "partnumber",
                        label: "Item Code",
                        thStyle: "width:150px",
                    },
                    {
                        key: "itemname",
                        label: "Item Name",
                    },
                    {
                        key: "typeseries",
                        label: "Type/series",
                    },
                    {
                        key: "qtyTrading",
                        label: "Quantity",
                        thStyle: "width:100px",
                        thClass: "text-center",
                        tdClass: "text-center"
                    },
                    {
                        key: "priceTrading", // diperoleh dari invunitcost * qtyTrading
                        label: "Price Trading",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "valueTrading", // diperoleh dari invunitcost * qtyTrading
                        label: "Value Trading",
                        thStyle: "width:120px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "action",
                        label: "Action",
                        thStyle: "width:40px",
                        thClass: "text-center",
                    },
                ],
                page: 1,
                limit: 5,
                total: 0,
            },
            issuedLinesObj:{iteminfo:'',itemno:'', description:'', qtyTrading:1, valueTrading:0, invunitom:'', qtyUndefined:0,remark:''},
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
        calcPPh:1,
            Warehouse : []
        };
    },
    computed: {
        dimension(){
            return this.$store.state.dimension;
        },
        invalidTradingLines() {
            this.$v.issuedLinesObj.$touch();
            return this.$v.issuedLinesObj.$invalid;
        },
        invalidModel() {
            this.$v.model.$touch();
            return this.$v.model.$invalid;
        },
        qtyTrading(){
            return this.issuedLinesObj.qtyTrading;
        },
        maxTradingDate(){
            return moment(new Date()).format('YYYY-MM-DD');
        },
        priceTrading(){
            return this.issuedLinesObj.priceTrading;
        },
        priceDiscPc(){
            return this.issuedLinesObj.priceDiscPc;
        },    
        priceDisc(){
            return this.issuedLinesObj.priceDisc;
        },    
        disctotal(){
            return this.model.ttldiskon;
        },    
        vattotal(){
            return this.model.ttlvat;
        },    

    },
    watch: {
        qtyTrading: function(newval) {
            // setTimeout(() => {
                this.calcAmount();
            // }, 100);
        },
        priceTrading: function(newval) {
            // console.log('priceTrading :',newval);
            // setTimeout(() => {
                this.calcAmount();
            // }, 100);
        },    
        priceDiscPc: function(newval) {
            this.issuedLinesObj.priceDisc = parseFloat((this.issuedLinesObj.priceTrading || 0)) * parseFloat(newval) / 100;        
            // this.calcAmount();
        },    
        priceDisc: function(newval) {
            this.calcAmount();
        },    
        disctotal: function(newval) {
            this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        },    
        vattotal: function(newval) {
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        },    
        salesKode: function(newval) {
            const item = this.salesAccounts.find(p => p.value==newval);
            this.issuedLinesObj.NamaSale=item.text;
        },    
        noPPN: function(newval) {
            if (newval) {
                this.model.nofaktur='';
                this.model.tglfaktur='';
            }
        },    
    },

    created: async function(){
        if (this.$route.params.tradingKey)  {
            toastr.info('Loading Request Detail, please wait')
            try {
            const [b,data] = await Promise.all([trading.store(),trading.detail(this.$route.params)]) ;
            
            this.Warehouse = b;
            const row = data[0][0];
            // console.log('row ==>',row)
            // this.saveEnabled=(row.send2wf === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            
            this.issuedLines.items = data[1]
            this.issuedLines.total=this.issuedLines.items.length;
            this.calcTotalDtlTrading();
            // this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            this.$forceUpdate();                
            toastr.clear;
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
            }
        } else {
            const b = await trading.store();
            this.model.tanggal = moment().format('YYYY-MM-DD');
            this.Warehouse = b;
        } 
    },
    methods: {
        closeTradingLines: function(){
            const opened= this.issuedLines.items.find( r=> r._showDetails==true);
            if (opened) opened._showDetails=false;
        },
        addTradingLines : function () {
            this.closeTradingLines();
            const obj={_showDetails:true};
            this.issuedLines.selected = obj;
            // for (var key in this.issuedLinesObj) {
            //     this.issuedLinesObj[key] = '';
            // }
            this.issuedLinesObj.iteminfo='';
            this.issuedLinesObj.itemno='';
            this.issuedLinesObj.description='';
            this.issuedLinesObj.remark='';
            this.issuedLinesObj.valueTrading=0;

            this.issuedLinesObj.invunitom='EACH';
            this.issuedLinesObj.qtyTrading = 1;
            this.issuedLinesObj.qtyUndefined = 0;
            this.updateDimHdr2Dtl(this.issuedLinesObj);
            this.issuedLines.items.push(obj);
            this.issuedLines.total=this.issuedLines.items.length;
            setTimeout(() => {
                const bfore = this.issuedLines.page;
                const after =Math.ceil((this.issuedLines.total)/this.issuedLines.limit);
                if (bfore != after){
                    this.issuedLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.issuedLines.total} items`,'Line/Detail',10000);
                }
            }, 100);            
        },
        editTradingLines : function (obj,callback) {
            this.closeTradingLines();
            this.issuedLines.selected = obj;
            this.issuedLinesObj.iteminfo='';
            this.issuedLinesObj.itemno='';
            this.issuedLinesObj.description='';
            this.issuedLinesObj.remark='';
            this.issuedLinesObj.valueTrading=0;

            this.issuedLinesObj.invunitom='EACH';
            this.issuedLinesObj.qtyTrading = 1;
            this.issuedLinesObj.qtyUndefined = 0;
            for (var key in obj) {
                this.issuedLinesObj[key] = obj[key];
            }
            this.issuedLinesObj.iteminfo = `${obj.itemno} | ${obj.itemname}`;
            this.issuedLinesObj.typeseries = `${obj.itemcategory}`;
            this.dimension.forEach((dim) => {
                if (obj[dim.value]) {
                    this.issuedLinesObj[dim.value] = obj[dim.value];
                    this.issuedLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                    this.issuedLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
                }
            });
            callback();
        },
        delTradingLines: function (index) {
            if (index > -1) {
                // this.issuedLines.items.splice(index, 1);
                const posisi = (this.issuedLines.page-1)*this.issuedLines.limit;
                this.issuedLines.items.splice(posisi+index, 1);
            }
            this.issuedLines.total=this.issuedLines.items.length;
            this.calcTotalDtlTrading();
        },
        saveTradingLines: async function (callback) {
            this.calcAmount();
            if (this.invalidTradingLines) {
                console.log('validation : ', this.$v.issuedLinesObj);
                console.log('model obj : ',this.issuedLinesObj);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
                try {
                        for (var key in this.issuedLinesObj) {
                            this.issuedLines.selected[key] = this.issuedLinesObj[key];
                        }
                        this.dimension.forEach((dim) => {
                            if (datadim[dim.value]) {
                                this.issuedLines.selected[dim.value] = datadim[dim.value];
                                this.issuedLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                            }
                        });
                        this.updateDimDtl2Hdr(datadim);
                        this.calcTotalDtlTrading();
                        this.issuedLines.selected._showDetails=false;
                        if (callback) callback();
                        if (this.inputLineBerlanjut==1) {
                            this.addTradingLines();
                            this.$v.issuedLinesObj.$reset();
                        }

                } catch (error) {
                    console.log('error : ', error);
                    if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }
                }
            }
        },
        save: async function () {
            if (!this.saveEnabled) {
                toastr.error('View mode cannot be Saved');
                return;
            }
            this.saveEnabled=false;
            if (this.invalidModel) {
                console.log('validation : ', this.$v.model);
                console.log('model obj : ',this.model);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
                this.saveEnabled=true;
            } else {
                try {
                    this.model.TableName = 'trading';
                    const dimValResult = await dimension.validate(this.model);
                    if (dimValResult.success) {
                        // this.model.DimTableKey = diisi dari PR/SR;
                        this.model.tradingKey = this.model.tradingKey || '';
                        this.model.nomor = this.model.nomor || '';
                        const row = {};
                        for (var key in this.model) {
                            row[key] = this.model[key];
                        }
                        row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                        row.diskonrkp = 0;
                        let lineno=1;
                        row.lines = this.issuedLines.items.reduce((newArr, item) => {
                            if (((item.itemno || '') != '') && (item.qtyTrading != 0)) {
                                item.lineno = lineno;
                                item.valueIssued = this.issuedLinesObj.invUnitCost * this.issuedLinesObj.qtyTrading;
                                row.diskonrkp += item.discTrading;    
                                newArr.push(item);
                                lineno += 1;
                            }
                            return newArr;
                        }, []);

                        if (row.lines.length>0) {
                            const hasil= await trading.save(row);
                            toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Trading",10000);

                            if (this.inputBerlanjut==0){
                                this.close();
                            } else {
                                this.saveEnabled=true;            
                                this.model.pembeli='';
                                this.model.pembeli=uraian='';
                                this.$v.model.$reset();                        
                            }

                        } else {
                            toastr.error('Please fill at least 1(one) Trading Detail', 'ERROR MESSAGE');
                            this.saveEnabled=true;
                        }
                    } else {
                        var msg = dimValResult.message || 'Dimension validation error';
                        toastr.error(msg, "ERROR MESSAGE");
                        this.saveEnabled=true;
                    }

                } catch (error) {
                    console.log('error : ', error);
                    toastr.error(JSON.stringify(error), "Save Trading Error");                
                    this.saveEnabled=true;
                }

            }
        },
        onSelectLkuItem(_selected) {
            for (const key in _selected) {
                // if (_selected.hasOwnProperty(key)) {
                if (_selected[key]) {
                    this.issuedLinesObj[key] = _selected[key];
                }
            }
            this.issuedLinesObj.iteminfo = _selected.partnumber.trim() + ' | ' + _selected.itemname.trim();
            // this.issuedLinesObj.description =  _selected.itemname.trim() + ' | ' + _selected.partnumber.trim();
            // this.issuedLinesObj.invunitom = _selected.invunitom;
            // this.issuedLinesObj.priceTrading = _selected.priceTrading;
            this.issuedLinesObj.priceTrading = _selected.priceTrading;
            // this.issuedLinesObj.expirDate = _selected.expirDate ? moment(_selected.expirDate).format('YYYY-MM-DD') : '';
            // this.issuedLinesObj.recivDate = _selected.recivDate ? moment(_selected.recivDate).format('YYYY-MM-DD') : '';
            this.calcAmount();
            this.lkuItemShow=false;
        },
        onSelectLkuCrew: function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
            this.model.crewinfo = lkuData.selected.crewname.trim() + ' | ' + lkuData.selected.crewnik.trim();
            this.model.crewkey = lkuData.selected.crewkey;
            this.model.dibayarke = this.model.dibayarke || lkuData.selected.crewname.trim();
            this.lkuCrewShow=false;
        },
        updateDimDtl2Hdr: function (dimDtl) {
            var dimHdr = this.model;
            this.dimension.forEach((dim) => {
                if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                    dimHdr[dim.value] = dimDtl[dim.value];
                    dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                    dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
                }
            });
            this.updateDimHdr = !this.updateDimHdr;
        },
        updateDimHdr2Dtl: function (dimDtl) {
            var dimHdr = this.model;
            dimDtl = dimDtl || this.issuedLinesObj;
            this.dimension.forEach((dim) => {
                if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                    dimDtl[dim.value] = dimHdr[dim.value];
                    dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                    dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
                }
            });
            this.updateDimDtl = !this.updateDimDtl;
        },
    calcAmount : function() {
        this.issuedLinesObj.grossTrading = parseFloat(this.issuedLinesObj.priceTrading || 0) * parseFloat(this.issuedLinesObj.qtyTrading || 0);
        this.issuedLinesObj.discTrading = parseFloat(this.issuedLinesObj.priceDisc  || 0) * parseFloat((this.issuedLinesObj.qtyTrading || 0));        
        this.issuedLinesObj.valueTrading = this.issuedLinesObj.grossTrading -this.issuedLinesObj.discTrading;
        this.issuedLinesObj.issueValue = parseFloat(this.issuedLinesObj.invUnitCost || 0) * parseFloat(this.issuedLinesObj.qtyTrading || 0);
        
        // console.log('calcAmount : ', this.issuedLinesObj);
        this.calcTaxes();
    },
    calcTaxes : function() {
        // this.issuedLinesObj.valueTrading = parseFloat(this.issuedLinesObj.grossTrading || 0) - parseFloat(this.issuedLinesObj.discTrading || 0);
        this.issuedLinesObj.dpp = parseFloat(this.issuedLinesObj.valueTrading  || 0);
        if (this.issuedLinesObj.kenappn == 1) {
            this.model.grossup = 0;
            this.issuedLinesObj.ppn = 10;
        } else {
            this.issuedLinesObj.dpp = 0;
            this.issuedLinesObj.ppn = 0;
        }

        this.issuedLinesObj.nilaippn = 0.1 * this.issuedLinesObj.dpp;
        this.issuedLinesObj.nilaidue = this.issuedLinesObj.valueTrading + this.issuedLinesObj.nilaippn;
        this.$forceUpdate();
    },
    calcTotalDtlTrading: function () {
        this.model.calcVAT = this.model.calcVAT || 1;
        this.model.calcDisc = this.model.calcDisc || 1;
        let nilaidpp = 0;
        let ttlvat = 0;
        let ttlgross = 0;
        let ttldiskon = 0;
        let totaldpp = 0;
        this.issuedLines.items.forEach((trx)=> {
            if (trx.itemno) {
                nilaidpp += (trx.dpp || 0);
                ttlgross += (trx.grossTrading || 0);
                ttldiskon += (trx.discTrading || 0);
                ttlvat += (trx.nilaippn || 0);
            }
        });
        this.model.nilaidpp = nilaidpp;
        this.model.ttlgross = ttlgross;
        if (this.model.calcVAT == 1){
            this.model.ttlvat = ttlvat;
        }
        if (this.model.calcDisc == 1){
            this.model.ttldiskon = ttldiskon;
        }
        this.model.ttlnetto =this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },
        close(){
        //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
        // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'logistic.issuedform')) {
        //     router.push({name:this.$store.state.prevRoute.name});
        // } else {
            router.push({name:'logistic.trading'});
        // }
        }
    }
};
</script>
